module.exports = __webpack_public_path__ + "static/media/POS_02_A.f3ef4be2.png";